<template>
  <div class="body-content">
    404
  </div>
</template>

<script>

export default {
  components: {}
}
</script>

<style scoped>
.body-content {
  padding: 20px;
}
</style>
